<template>
    <div v-if="errors.length > 0" :class="defaultClass">
        <template v-if="errors.length === 1">
            {{ firstError }}
        </template>

        <ul v-else class="m-0 pl-0">
            <li v-for="(message, index) in errors" :key="index">
                {{ message }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'FieldErrors',

    props: {
        errors: {type: Array, default: () => []},
    },

    computed: {
        defaultClass() {
            if (this.$vnode.data.staticClass) {
                return null;
            }

            return 'text-danger';
        },

        firstError() {
            return this.errors[0];
        },
    },
};
</script>
